import React from 'react';
import {Container} from 'react-bootstrap';
import Image1 from '../../assets/png/banner/1.png';
import Image2 from '../../assets/png/banner/2.png';
import Image3 from '../../assets/png/banner/3.png';
import Image4 from '../../assets/png/banner/4.png';
import Image5 from '../../assets/png/banner/5.png';
import Image6 from '../../assets/png/banner/6.png';
import Image7 from '../../assets/png/banner/7.png';
import Image8 from '../../assets/png/banner/8.png';
import Image9 from '../../assets/png/banner/9.png';
import Image10 from '../../assets/png/banner/10.png';
import Image11 from '../../assets/png/banner/11.png';
import Image12 from '../../assets/png/banner/12.png';
import './Banner.scss';

const FondoColor = ({body}) => {
    return (
        <Container fluid className='banner__container'>
            <img src={Image1} alt="" className='imagen__fondo'/>
            <img src={Image2} alt="" className='imagen__fondo'/>
            <img src={Image3} alt="" className='imagen__fondo'/>
            <img src={Image4} alt="" className='imagen__fondo'/>
            <img src={Image5} alt="" className='imagen__fondo'/>
            <img src={Image6} alt="" className='imagen__fondo'/>
            <img src={Image7} alt="" className='imagen__fondo'/>
            <img src={Image8} alt="" className='imagen__fondo'/>
            <img src={Image9} alt="" className='imagen__fondo'/>
            <img src={Image10} alt="" className='imagen__fondo'/>
            <img src={Image11} alt="" className='imagen__fondo'/>
            <img src={Image12} alt="" className='imagen__fondo'/>
            {body}
        </Container>
    );
}

export default FondoColor;
